import type { CompanyContact } from "../../../api/client.ts";
import BoardGraph from "../../../components/companies/BoardGraph.tsx";
import SectionCard from "../../../components/SectionCard.tsx";

interface BoardStructureCardProps {
  contacts: CompanyContact[];
  companyName: string;
}

export default function BoardStructureCard({ contacts, companyName }: BoardStructureCardProps) {
  if (contacts.length === 0) return null;
  return (
    <SectionCard title="Board structure">
      <BoardGraph contacts={contacts} companyName={companyName} />
    </SectionCard>
  );
}
